import { format } from 'date-fns';

const formatDate = (date: string): string => {
  const parseDate = new Date(date);
  return format(parseDate, 'iii, MMM d');
};

export default formatDate;
